import React, { useReducer, useContext, useEffect, useMemo } from 'react';
import { Box, TextField } from '@mui/material';
import { IconButton } from '@mui/material';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import { externalComponent } from '../../AppRoutes';
import { lockedReducer } from '../../Utils/reducers';
import { api } from '../../../services/api';
import DefaultModal from "../../Utils/DefaultModal";
import { formatCurrency } from '../../Utils/IntegerOnly';
import Table, { TableHook } from '../../Table';
import ColorButton from '../../Buttons/ColorButton';
import { NumericFormatInput } from '../../Utils/NumericInput';

const url = '/novopedido/'

const moveProduct = (table, setState, state, row) => {

    let listProducts = null
    let listSelectedProducts = null

    if (table === 'products') {
        const toMoveSelectedProducts = state.products.filter(each => each.id === row.id)

        listProducts = state.products.filter(product => {
            return !toMoveSelectedProducts.some(selected_product => selected_product.id === product.id);
        });

        listSelectedProducts = [...state.selected_products, ...toMoveSelectedProducts].sort((a, b) => {
            return (b.EstoqueDisponivel !== a.EstoqueDisponivel) ? b.EstoqueDisponivel - a.EstoqueDisponivel : a.id - b.id;
        });
        setState({ products: listProducts, selected_products: listSelectedProducts })
    } else if (table === 'selected_products') {
        const toMoveProducts = state.selected_products.filter(each => each.id === row.id);
        listSelectedProducts = state.selected_products.filter(selected_product => {
            return !toMoveProducts.some(product => product.id === selected_product.id);
        });
        listProducts = [...state.products, ...toMoveProducts].sort((a, b) => a.id - b.id);
        
        setState({ products: listProducts, selected_products: listSelectedProducts });
    }

}

const filterCod = (value, state, setState) => {
    if (value === '') {
        let listSelectedReset = state.resetRows.filter(product => {
            return !state.selected_products.some(selected_product => selected_product.id === product.id);
        });
        let listSelectedResetRows = [...listSelectedReset].sort((a, b) => a.id - b.id);
        setState({ searchCod: value, products: listSelectedResetRows })
    } else {
        const rows = state.resetRows.filter(row =>
            row.Cod.toString() === value && !state.selected_products.some(product => product.id === row.id)
        );
        setState({ searchCod: value, products: rows })
    }
}

const filterDescricao = (value, state, setState) => {
    if (value === '') {
        let listSelectedReset = state.resetRows.filter(product => {
            return !state.selected_products.some(selected_product => selected_product.id === product.id);
        });
        let listSelectedResetRows = [...listSelectedReset].sort((a, b) => a.id - b.id);
        setState({ searchDescricao: value, products: listSelectedResetRows })
    } else {
        const rows = state.resetRows.filter(row =>
            row.Descricao.toLowerCase().includes(value.toLowerCase()) && !state.selected_products.some(product => product.id === row.id)
        );
        setState({ searchDescricao: value, products: rows })
    }
}

const changeData = (props, rows, newvalue) => {
    const row = rows.find(row => row.id === props.row.id)
    const value = {id: props.row.id, [props.field]: newvalue}
    row[props.field] = value[props.field]
    props.api.updateRows([value])
}

// const changeQuant = (props, rows, newvalue) => {
//     const row = rows.find(row => row.id === props.row.id)
//     const value = {id: props.row.id, [props.field]: newvalue}
//     row.QuantidadeVenda = value.QuantidadeVenda
//     props.api.updateRows([value])
// }

// const changePrice = (props, rows, newvalue) => {
//     const row = rows.find(row => row.id === props.row.id)
//     const value = {id: props.row.id, [props.field]: newvalue}
//     row.preco = value.preco
//     props.api.updateRows([value])
// }

const getcolumns = (setState, state) => {
    const columns = []
    columns.push({ field: 'Cod', headerName: 'Código', flex: 0.1, width: 100 })
    columns.push({ field: 'Descricao', headerName: 'Descrição', flex: 1 })
    columns.push({
        field: 'QuantidadeVenda', headerName: 'Quantidade', flex: 0.2,
        renderCell: (props) => {
            return (
                <Box sx={{ width: '90%' }}>
                    <TextField
                        value={props.row.QuantidadeVenda}
                        type="text"
                        onChange={(e) => changeData(props, state.products, e.target.value)}
                        InputProps={{
                            sx: { fontSize: '13px' }
                        }}
                    />
                </Box>)
        }
    })
    columns.push({
        field: 'preco', headerName: 'Preço', flex: 0.4, filterType: 'string',
        renderCell: ( props ) => <Box sx={{ width: '90%' }}>
        <TextField
            //autoFocus={true}
            value={props.value/100}
            type="text"
            onChange={(e) => changeData(props, state.products, e.target.value*100)}
            onKeyDown={(e) => e.stopPropagation()}
            InputProps={{
                inputComponent: NumericFormatInput,
                sx: { fontSize: '13px' }
            }}
        />
    </Box>
    })
    columns.push({ field: 'EstoqueDisponivel', headerName: 'Estoque Disponível', flex: 0.2, filterType: 'string' })
    columns.push({
        field: 'acoes',
        headerName: '',
        flex: 0.1,
        width: 100,
        renderCell: (props) => {
            return (
                <Box>
                    <IconButton onClick={() => moveProduct('products', setState, state, props.row)}><ArrowCircleRightIcon sx={{ color: '#479760' }} className='arrowIcon' /></IconButton>
                </Box>
            )
        }
    })
    return columns
}

const getcolumns_selected = (setState, state) => {
    const columns_selected = []
    columns_selected.push({
        field: 'acoes',
        headerName: '',
        flex: 0.1,
        width: 100,
        renderCell: (props) => {
            return (
                <Box>
                    <IconButton onClick={() => moveProduct('selected_products', setState, state, props.row)}><ArrowCircleLeftIcon sx={{ color: '#a14949' }} className='arrowIcon' /></IconButton>
                </Box>
            )
        }
    })
    columns_selected.push({ field: 'Cod', headerName: 'Código', flex: 0.2, width: 100 })
    columns_selected.push({ field: 'Descricao', headerName: 'Descrição', width: 300 })
    columns_selected.push({
        field: 'QuantidadeVenda', headerName: 'Quantidade', flex: 0.2,
        renderCell: (props) => {
            return (
                   <Box sx={{ width: '90%' }}>
                    <TextField
                        //autoFocus={true}
                        value={props.row.QuantidadeVenda}
                        type="text"
                        onChange={(e) => changeData(props, state.selected_products, e.target.value)}
                        InputProps={{
                            sx: { fontSize: '13px' }
                        }}
                    />
                </Box>)
        }
    })
    return columns_selected
}


const getProducts = async (setLoader, setState, state) => {
    if (!state.tabela_id) return
    setLoader(true)
    const res = await api.post(`/tabelas/produtos/${state.tabela_id}/${state.origin_stock?.id || 0}`)

    if (res.status === 200) {
        const selected_ids = state.selected_products.map(selected_product => selected_product.id);
        const data = res.data.map(each => ({ ...each, id: each.Cod, checked: false })).filter(product => !selected_ids.includes(product.id));
        setState({ products: data, resetRows: data, ready: true })
    } else {
        setState({ready: true})
    }
    setLoader(false)

}

const ProductModal = ({ handleClose, setSelectedProducts, setProducts, productsSelecteds, tabela_id, origin_stock }) => {

    const [state, setState] = useReducer(lockedReducer, {
        QuantidadeVenda: 0,
        tabela_id: tabela_id,
        products: [],
        selected_products: [...productsSelecteds],
        resetRows: [],
        searchCod: '',
        searchDescricao: '',
        ready: false,
        origin_stock: origin_stock || 0
    })

    const { setLoader } = useContext(externalComponent)

    useEffect(() => {
        if (state.products.length <= 0) {
            getProducts(setLoader, setState, state)
        };
    }, [])

    const setColumns = useMemo(() => getcolumns(setState, state), [state.products, state.edit, state.selected_products])
    const selectedColumns = useMemo(() => getcolumns_selected(setState, state), [state.selected_products, state.products])

    return (
        <>
            {state.ready && <DefaultModal
                dialogProps={{
                    sx: {
                        '& .MuiPaper-root': {
                            maxWidth: 'unset',
                            maxHeight: 'unset',
                            width: '95%',
                            height: '95%',
                            margin: '0px',

                            '@media (min-width: 1600px)': {
                                width: '80%',
                                height: '80%',
                            },
                        }
                    }
                }}
                handleClose={handleClose}
                open={true}
                title={`Produtos do Pedido`}
                content={

                    <Box className='item-content-modal noborder' sx={{ height: '100%' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                            <TextField
                                id="searchCod"
                                type="text"
                                label="Código"
                                size='small'
                                value={state.searchCod}
                                onChange={(e) => { filterCod(e.target.value, state, setState) }}
                                onKeyDown={(e) => { filterCod(e.target.value, state, setState) }}
                                fullWidth={false}
                                sx={{ width: '6rem' }}
                            />

                            <TextField
                                id="searchDescricao"
                                type="text"
                                label="Descrição"
                                size='small'
                                value={state.searchDescricao}
                                onChange={(e) => { filterDescricao(e.target.value, state, setState) }}
                                onKeyDown={(e) => { filterDescricao(e.target.value, state, setState) }}
                                fullWidth={false}
                                sx={{ width: '17rem' }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', gap: '1rem', width: '100%', minHeight: '1rem', height: '100%' }}>
                            <Box sx={{ width: '65%' }}>
                                <Table
                                    disableRowSelectionOnClick
                                    key='select-products-table-1'
                                    paginationMode='client'
                                    className='contabil-grid'
                                    rows={state.products}
                                    columns={setColumns}
                                    rowHeight={30}
                                />
                            </Box>
                            <Box sx={{ width: '35%' }}>
                                <Table
                                    disableRowSelectionOnClick
                                    key='select-products-table-2'
                                    paginationMode='client'
                                    className='contabil-grid'
                                    rows={state.selected_products}
                                    columns={selectedColumns}
                                    rowHeight={30}
                                />
                            </Box>
                        </Box>
                    </Box>

                }

                action={
                    <ColorButton onClick={() => { setSelectedProducts(setProducts, state.selected_products); handleClose() }}>Salvar</ColorButton>
                }
            />}
        </>
    )
}

export default ProductModal;